//#region src/helpers/id-generator.ts
var e = "0123456789abcdef";
function t(t) {
	let n = "";
	for (let r = 0; r < t; r++) {
		let t = Math.floor(Math.random() * 16);
		n += e[t];
	}
	return n;
}
function n() {
	return `h_${t(10)}`;
}
//#endregion
export { n as generateHeadingId };
